import styles from "./EliminateGame.module.less";
import NoticeText from "../components/NoticeText";
import DownTime from "../components/DownTime";
import DSBridge from "dsbridge";
import { useState, useEffect, useRef } from "react";
import { getGameAudio, getMaterialsByGame } from "@/api/mine";
import { showDeviceModal } from "views/mine/device-manage/components/device-modal";
import { Toast } from "react-vant";
import { useSearchParams } from "react-router-dom";

const EliminateGame = () => {
  const [searchParams] = useSearchParams();
  const [isVisible, setIsVisible] = useState(true);
  const [cards, setCards] = useState([]);
  const [lights, setLights] = useState(Array.from({ length: 6 }, () => false));
  const explanationRef = useRef(null);
  const downTimeRef = useRef(null);
  const isStartRef = useRef(false);

  const handleClose = () => {
    showDeviceModal({
      message:
        "确定退出课堂练习？中途退出无法获得积分哦~退出后将继续学习课程。",
      onConfirm: () => {
        DSBridge.call("stopSound", "bgm_sound");
        DSBridge.call("exitWebView");
      },
      isShowCancel: true,
      isShowConfirm: true,
      cancelText: "取消",
      confirmText: "退出",
    });
  };

  const handleGetAudio = async (text) => {
    try {
      // const res = await getGameAudio({
      //   character_id: "lily_white",
      //   token: "IMdW6ZWukrH6qrUteWDa6Mzm-SR-zPxW3z1Iq-2xg08.",
      //   text: text,
      // });
      const res = await getGameAudio({
        character_id: searchParams.get("character_id"),
        token: searchParams.get("token"),
        text: text,
      });
      if (res.code === 200 && res.data?.url) {
        return res.data.url;
      }
      throw new Error("Failed to get audio URL");
    } catch (error) {
      throw error;
    }
  };

  // 提取播放音频和退出的公共逻辑
  const playAudioAndExit = async (explanationText, score = 0) => {
    try {
      const audioUrl = await handleGetAudio(explanationText);
      DSBridge.call(
        "playOnlineSound",
        `${process.env.REACT_APP_API_CDN}/${audioUrl}`,
        () => {
          if (score > 0) {
            DSBridge.call("addScore", score.toString());
          }
          DSBridge.call("exitWebView");
        }
      );
    } catch {
      if (score > 0) {
        DSBridge.call("addScore", score.toString());
      }
      DSBridge.call("exitWebView");
    }
  };

  const handleCardClick = (index) => {
    if (isStartRef.current === false || cards[index].isAlleadyMatch) {
      return;
    }
    const copyCards = JSON.parse(JSON.stringify(cards));
    if (
      !cards[index].isFlipped &&
      cards.filter((item) => item.isFlipped && !item.isAlleadyMatch).length < 2
    ) {
      setCards((prev) =>
        prev.map((item, i) =>
          i === index ? { ...item, isFlipped: true } : item
        )
      );
      const findIndex = copyCards.findIndex(
        (item) => item.isFlipped && !item.isAlleadyMatch
      );
      if (findIndex !== -1) {
        if (copyCards[findIndex].id === copyCards[index].id) {
          setTimeout(() => {
            setCards((prev) =>
              prev.map((item, i) =>
                i === index || i === findIndex
                  ? { ...item, isFlipped: true, isAlleadyMatch: true }
                  : item
              )
            );
            DSBridge.call("playSound", "correct_sound");
          }, 1000);
        } else {
          setTimeout(() => {
            setCards((prev) =>
              prev.map((item, i) =>
                i === index || i === findIndex
                  ? { ...item, isFlipped: false }
                  : item
              )
            );
            DSBridge.call("playSound", "aou_sound");
          }, 1000);
        }
      }
    }
  };
  const handleTimeEnd = () => {
    DSBridge.call("stopSound", "bgm_sound");
    isStartRef.current = false;
    setCards((prev) =>
      prev.map((item) => ({ ...item, isFlipped: true, isAlleadyMatch: false }))
    );
    const hadAnyPieces =
      cards.findIndex((item) => item.isAlleadyMatch === true) !== -1;
    if (hadAnyPieces) {
      DSBridge.call("playSVGA", "nice_try", async () => {
        playAudioAndExit(explanationRef.current?.incorrect, 5);
      });
    } else {
      DSBridge.call("playSVGA", "missed", async () => {
        playAudioAndExit(explanationRef.current?.noAnswer);
      });
    }
  };
  const initGame = async () => {
    try {
      // const res = {
      //   code: 200,
      //   status: true,
      //   data: {
      //     type: 14,
      //     question: "It's practice time!",
      //     question_zh: "",
      //     answer: "",
      //     image:
      //       "https://cdn03.myaitalk.vip/utalkrc/materials/slides/test_test/test_test-unit_1_tts_test_111301/edit_image_80c025fd-23e9-43a9-ac49-4b10f27c01cd.png",
      //     practice_config: {
      //       type: "elimination",
      //       guide:
      //         "Find the cards that go together. Can you match the pictures with the correct words",
      //       duration: 15,
      //       explanation: {
      //         correct:
      //           "Great job! You matched the picture with the right word.",
      //         incorrect: "Not quite. That word doesn't match the picture.",
      //         noAnswer:
      //           "Time's up! Try to match the word and picture next time.",
      //       },
      //       config: {
      //         cards: [
      //           {
      //             image:
      //               "https://cdn03.myaitalk.vip/utalkrc/materials/slides/test_test/test_test-unit_1_tts_test_111301/practice_images/material_practice_image_5fd3e198-4a8e-4a64-b47f-dce9db5b4404.png",
      //             id: "a",
      //           },
      //           {
      //             image:
      //               "https://cdn03.myaitalk.vip/utalkrc/materials/slides/test_test/test_test-unit_1_tts_test_111301/practice_images/material_practice_image_50be1084-c2d6-4f03-abd6-00a417afb5c2.png",
      //             id: "b",
      //           },
      //           {
      //             image:
      //               "https://cdn03.myaitalk.vip/utalkrc/materials/slides/test_test/test_test-unit_1_tts_test_111301/practice_images/material_practice_image_d20ef840-e1b2-414e-b56a-8d16d97ad609.png",
      //             id: "c",
      //           },
      //           {
      //             image:
      //               "https://cdn03.myaitalk.vip/utalkrc/materials/slides/test_test/test_test-unit_1_tts_test_111301/practice_images/material_practice_image_3d4bdbd6-8b64-4e24-a136-0c74373b759f.png",
      //             id: "a",
      //           },
      //           {
      //             image:
      //               "https://cdn03.myaitalk.vip/utalkrc/materials/slides/test_test/test_test-unit_1_tts_test_111301/practice_images/material_practice_image_4fc72e5d-e961-45b0-befa-d4977b24da99.png",
      //             id: "c",
      //           },
      //           {
      //             image:
      //               "https://cdn03.myaitalk.vip/utalkrc/materials/slides/test_test/test_test-unit_1_tts_test_111301/practice_images/material_practice_image_8b720ee3-a787-4441-9c40-4e670b184801.png",
      //             id: "b",
      //           },
      //         ],
      //       },
      //     },
      //   },
      //   message: "success",
      // };
      const res = await getMaterialsByGame({
        material_id: searchParams.get("material_id"),
        token: searchParams.get("token"),
        unit_id: searchParams.get("unit_id"),
      });
      if (res.code === 200) {
        const config = res.data?.practice_config;
        if (config?.type !== "elimination") {
          Toast.info("游戏类型错误，请点击左上角退出");
          return;
        }
        explanationRef.current = config?.explanation;
        setCards(
          config?.config?.cards.map((item) => ({
            ...item,
            isFlipped: true,
            isAlleadyMatch: false,
          })) || []
        );

        try {
          const audioUrl = await handleGetAudio(config?.guide);
          DSBridge.call(
            "playOnlineSound",
            `${process.env.REACT_APP_API_CDN}/${audioUrl}`,
            () => {
              setCards((prev) =>
                prev.map((item) => ({ ...item, isFlipped: false }))
              );
              setTimeout(() => {
                downTimeRef.current?.startCountdown(config?.duration);
                isStartRef.current = true;
              }, 1000);
            }
          );
        } catch {
          setCards((prev) =>
            prev.map((item) => ({ ...item, isFlipped: false }))
          );
          setTimeout(() => {
            downTimeRef.current?.startCountdown(config?.duration);
            isStartRef.current = true;
          }, 1000);
        }
      } else {
        Toast.info("请求游戏数据失败，请点击左上角退出");
      }
    } catch {
      Toast.info("验证游戏数据失败，请点击左上角退出");
    }
  };
  useEffect(() => {
    if (cards.length > 0) {
      // 1. 更新灯光状态
      const matchedCount = cards.filter(
        (item) => item.isAlleadyMatch === true
      ).length;
      setLights(Array.from({ length: 6 }, (_, index) => index < matchedCount));

      // 2. 检查游戏是否完成
      const hasUnmatchedCards = cards.some(
        (item) => item.isAlleadyMatch === false
      );
      if (!hasUnmatchedCards) {
        DSBridge.call("stopSound", "bgm_sound");
        downTimeRef.current.stopCountdown();
        isStartRef.current = false;
        setCards((prev) =>
          prev.map((item) => ({
            ...item,
            isFlipped: true,
            isAlleadyMatch: false,
          }))
        );
        DSBridge.call("playSVGA", "outstanding", () => {
          playAudioAndExit(explanationRef.current?.correct, 10);
        });
      }
    }
  }, [cards]);
  useEffect(() => {
    DSBridge.call("playSound", "bgm_sound");
    DSBridge.call("playSound", "start_sound");
    setTimeout(() => {
      setIsVisible(false);
    }, 1000);
    initGame();
    return () => {
      DSBridge.call("stopSound", "bgm_sound");
    };
  }, []);
  return (
    <div className={styles["eliminate-game-container"]}>
      {isVisible && (
        <div className={styles["start-box"]}>
          <img
            src={require("@/images/new-game/common/start.png")}
            className={styles["start-cover"]}
          />
        </div>
      )}
      <div className={`${isVisible ? styles["visibility-box"] : ""}`}>
        <div className={styles["back-top"]}></div>
        <div className={styles["back-bottom"]}></div>
        <div className={styles["center"]}>
          <div className={styles["center-title"]}>
            <div className={styles["title-text"]}>POP STAR</div>
          </div>
          {lights.map((_, index) => {
            return (
              <div
                key={index}
                className={`${
                  lights[index] === true
                    ? styles["center-light--open"]
                    : styles["center-light--close"]
                } ${styles[`center-light-${index + 1}`]}`}
              ></div>
            );
          })}
          <div className={styles["center-operate"]}>
            <div className={styles["center-operate-content"]}>
              {cards.length > 0 &&
                cards.map((item, index) => {
                  return (
                    <div
                      key={`eliminate-${index}`}
                      className={`${styles["content-item"]} ${
                        item.isFlipped ? styles["is-flipped"] : ""
                      } ${
                        item.isAlleadyMatch ? styles["is-alleady-match"] : ""
                      }`}
                      onClick={() => handleCardClick(index)}
                    >
                      <div className={styles["content-item--back"]}></div>
                      <div className={styles["content-item--front"]}>
                        <img
                          className={styles["back-image"]}
                          src={item.image}
                        />
                      </div>
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
        <NoticeText text=" Match  快速记忆卡片，点击含义相同的图片匹配" />
        <DownTime ref={downTimeRef} onTimeEnd={handleTimeEnd} />
      </div>
      <div className={styles["close-icon"]} onClick={handleClose}>
        <img
          className={styles["close-icon-img"]}
          src={require("@/images/new-game/common/close.png")}
        />
      </div>
    </div>
  );
};

export default EliminateGame;
